import React, {useCallback, useContext, useState} from 'react';
import {Accordion} from "react-bootstrap";
import AccordionContext, {isAccordionItemSelected} from 'react-bootstrap/AccordionContext';
import AccordionItemContext from 'react-bootstrap/AccordionItemContext';

function EnhancedAccordionBody({createChildren, children, ...rest}) {
    const {activeEventKey} = useContext(AccordionContext);
    const {eventKey} = useContext(AccordionItemContext);
    const [hasBeenExpanded, setHasBeenExpanded] = useState(false);
    const showChildren = createChildren === 'whenExpanded'
        ? isAccordionItemSelected(activeEventKey, eventKey)
        : createChildren === 'whenFirstExpanded'
            ? hasBeenExpanded
            : true;
    const onEnter = useCallback(() => {
        setHasBeenExpanded(true);
    }, []);
    return (
        <Accordion.Body onEnter={onEnter} {...rest}>
            {showChildren && children}
        </Accordion.Body>
    );
}

export default EnhancedAccordionBody;